import { render } from "./NotificationsPage.vue?vue&type=template&id=1a3b5924&scoped=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"

import "./NotificationsPage.vue?vue&type=style&index=0&id=1a3b5924&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3b5924"]])

export default __exports__